var React = require('react');

var Row = require('react-bootstrap/lib/Row');
var Col = require('react-bootstrap/lib/Col');
var FormGroup = require('react-bootstrap/lib/FormGroup');
var ControlLabel = require('react-bootstrap/lib/ControlLabel');
var InputGroup = require('react-bootstrap/lib/InputGroup');
var FormControl = require('react-bootstrap/lib/FormControl');
var Toggle = require('../Toggle/Toggle');

var Settings = React.createClass({

	getInitialState: function() {
		return {
			fees: '',
			nightPrice:'',
			hourBegin: '',
			hourEnd: '',
			minimumDistance: '',
			minimumPrice: '',
			kmPrice: '',
			kmPriceNight: '',
			registryPrice: '',
			bankPrice: '',
			mailPrice: '',
			waitPrice: '',
			worldtennisPrice: '',
			worldtennisCourierPrice: ''
		}
	},

	componentWillMount: function() {
		this.props.load();
	},

	componentWillUnmount: function() {
		this.props.unload();
	},

	componentWillReceiveProps: function(nextProps) {
		this.setState(nextProps.settings);
	},

	changeDeposit: function() {
		var me = this, props = me.props, settings = props.settings;

		props.update('depositEnable', !settings.depositEnable);
	},

	parseType: function(config, value) {
		var parsed = value;

		switch(config) {
			case 'kmPrice':
			case 'kmPriceNight':
			case 'nightPrice':
			case 'minimumDistance':
			case 'minimumPrice':
			case 'registryPrice':
			case 'bankPrice':
			case 'mailPrice':
			case 'waitPrice':
			case 'worldtennisPrice':
			case 'worldtennisCourierPrice':
				parsed = parseInt(value, 10);
				break;

			case 'fees':
				parsed = parseFloat(value);
				break;

			/*case 'hourBegin':
			case 'hourEnd':
				let hour = parseInt(value.substring(0,2));
				let minutes = parseInt(value.substring(3,5));
				parsed = (hour*60)+minutes;
				break;*/

			default:
				parsed = value;
		}

		return parsed;
	},

	handleChange(e){
		var me = this, config = e.target.name, value = e.target.value;

		me.setState({[config]: value});

		me.props.update([config], me.parseType(config, value));
	},

	updateConfigPrice: function(e) {
		var me = this, config = 'kmPrice/' + e.target.name + '/price';

		me.props.update([config], me.parseType('kmPrice', e.target.value));
	},

	updateConfigPriceNight: function(e) {
		var me = this, config = 'kmPriceNight/' + e.target.name + '/price';

		me.props.update([config], me.parseType('kmPriceNight', e.target.value));
	},

	getPricesList: function() {
		var me = this, priceConfig = me.props.settings.kmPrice;

		if (!priceConfig)
			return;

		let configs = priceConfig.map((config) => {
			return (
				<InputGroup key={config.key} style={{marginBottom: '2px'}}>
					<InputGroup.Addon>{config.markLabel}</InputGroup.Addon>
					<FormControl 
						onChange={me.updateConfigPrice}
						name={config.key}
						type="number" 
						defaultValue={config.price}
						 />
				</InputGroup>
			)
		});

		return configs;
	},

	getPricesNightList: function() {
		var me = this, priceNightConfig = me.props.settings.kmPriceNight;

		if (!priceNightConfig)
			return;

		let configs = priceNightConfig.map((config) => {
			console.log("config", config);
			return (
				<InputGroup key={config.key} style={{marginBottom: '2px'}}>
					<InputGroup.Addon>{config.markLabel}</InputGroup.Addon>
					<FormControl 
						onChange={me.updateConfigPriceNight}
						name={config.key}
						type="number" 
						defaultValue={config.price}
						 />
				</InputGroup>
			)
		});

		return configs;
	},

	render: function() {
		var me = this, settings = me.props.settings;
		
		return (
			<div style={{padding: '20px'}}>

				<Row className="show-grid">
					<Col sm={6}> 
						<Row className="show-grid">
							<Col sm={12}>
								<Toggle label="Depósito bancário"
										showTitle={true} 
										checked={settings.depositEnable} 
										onChange={me.changeDeposit} />
							</Col>
						</Row>
							
						<Row className="show-grid">		      
							<Col sm={12}> 
								<FormGroup bsSize="small">
									<ControlLabel> {"Comissão da casa"} </ControlLabel>
									<InputGroup>
										<InputGroup.Addon>{"%"}</InputGroup.Addon>
										<FormControl 
											name="fees"
											type="number" 
											value={me.state.fees}
											onChange={me.handleChange} />
									</InputGroup>
								</FormGroup>
							</Col>
						</Row>

						<Row className="show-grid">		      
							<Col sm={12}> 
								<FormGroup bsSize="small">
									<ControlLabel> {"Cartório"} </ControlLabel>
									<InputGroup>
										<InputGroup.Addon>{"¢"}</InputGroup.Addon>
										<FormControl 
											name="registryPrice"
											type="number" 
											value={me.state.registryPrice}
											onChange={me.handleChange} />
									</InputGroup>
								</FormGroup>
							</Col>
						</Row>

						<Row className="show-grid">		      
							<Col sm={12}> 
								<FormGroup bsSize="small">
									<ControlLabel> {"Banco"} </ControlLabel>
									<InputGroup>
										<InputGroup.Addon>{"¢"}</InputGroup.Addon>
										<FormControl 
											name="bankPrice"
											type="number" 
											value={me.state.bankPrice}
											onChange={me.handleChange} />
									</InputGroup>
								</FormGroup>
							</Col>
						</Row>

						<Row className="show-grid">		      
							<Col sm={12}> 
								<FormGroup bsSize="small">
									<ControlLabel> {"Correio"} </ControlLabel>
									<InputGroup>
										<InputGroup.Addon>{"¢"}</InputGroup.Addon>
										<FormControl 
											name="mailPrice"
											type="number" 
											value={me.state.mailPrice}
											onChange={me.handleChange} />
									</InputGroup>
								</FormGroup>
							</Col>
						</Row>

						<Row className="show-grid">		      
							<Col sm={12}> 
								<FormGroup bsSize="small">
									<ControlLabel> {"Entrega com espera"} </ControlLabel>
									<InputGroup>
										<InputGroup.Addon>{"¢"}</InputGroup.Addon>
										<FormControl 
											name="waitPrice"
											type="number" 
											value={me.state.waitPrice}
											onChange={me.handleChange} />
									</InputGroup>
								</FormGroup>
							</Col>
						</Row>

						<Row className="show-grid">
							<Col sm={6}> 
								<FormGroup bsSize="small">
									<ControlLabel> {"Adicional noturno"} </ControlLabel>
									<InputGroup>
										<InputGroup.Addon>{"¢"}</InputGroup.Addon>
										<FormControl 
											name='nightPrice'
											type="number" 
											value={me.state.nightPrice}
											onChange={me.handleChange} />
									</InputGroup>
								</FormGroup>
							</Col>
							<Col sm={3}> 
								<FormGroup bsSize="small">
									<ControlLabel> {"Horário"} </ControlLabel>
									<InputGroup>
										<InputGroup.Addon>{"Início"}</InputGroup.Addon>
										<FormControl 
											name='hourBegin'
											type="time" 
											value={me.state.hourBegin}
											onChange={me.handleChange} />
									</InputGroup>
								</FormGroup>
							</Col>
							<Col sm={3}> 
								<FormGroup bsSize="small">
									<ControlLabel> {"Horário"} </ControlLabel>
									<InputGroup>
										<InputGroup.Addon>{"Fim"}</InputGroup.Addon>
										<FormControl 
											name='hourEnd'
											type="time" 
											value={me.state.hourEnd}
											onChange={me.handleChange} />
									</InputGroup>
								</FormGroup>
							</Col>
						</Row>

						<Row className="show-grid">
							<Col sm={6}> 
								<FormGroup bsSize="small">
									<ControlLabel> {"Preço mínimo"} </ControlLabel>
									<InputGroup>
										<InputGroup.Addon>{"¢"}</InputGroup.Addon>
										<FormControl 
											name='minimumPrice'
											type="number" 
											value={me.state.minimumPrice}
											onChange={me.handleChange} />
									</InputGroup>
								</FormGroup>
							</Col>
							<Col sm={6}> 
								<FormGroup bsSize="small">
									<ControlLabel> {"Distância mínima"} </ControlLabel>
									<InputGroup>
										<InputGroup.Addon>{"m"}</InputGroup.Addon>
										<FormControl 
											name='minimumDistance'
											type="number" 
											value={me.state.minimumDistance}
											onChange={me.handleChange} />
									</InputGroup>
								</FormGroup>
							</Col>
						</Row>

						<Row className="show-grid">
							<Col sm={6}> 
								<FormGroup bsSize="small">
									<ControlLabel> {"Preço World Tennis"} </ControlLabel>
									<InputGroup>
										<InputGroup.Addon>{"¢"}</InputGroup.Addon>
										<FormControl 
											name='worldtennisPrice'
											type="number" 
											value={me.state.worldtennisPrice}
											onChange={me.handleChange} />
									</InputGroup>
								</FormGroup>
							</Col>
							<Col sm={6}> 
								<FormGroup bsSize="small">
									<ControlLabel> {"Valor Entregador World Tennis"} </ControlLabel>
									<InputGroup>
										<InputGroup.Addon>{"¢"}</InputGroup.Addon>
										<FormControl 
											name='worldtennisCourierPrice'
											type="number" 
											value={me.state.worldtennisCourierPrice}
											onChange={me.handleChange} />
									</InputGroup>
								</FormGroup>
							</Col>
						</Row>
					</Col>

					<Col sm={3}> 
						<Row className="show-grid">
							<div style={{padding: '20px'}}>
								<Col sm={12}> 
									<FormGroup bsSize="small">
										<ControlLabel> {"Preço p/ kilometragem"} </ControlLabel>
										{me.getPricesList()}
									</FormGroup>
								</Col>
							</div>
						</Row>
					</Col>
					<Col sm={3}> 
						<Row className="show-grid">
							<div style={{padding: '20px'}}>
								<Col sm={12}> 
									<FormGroup bsSize="small">
										<ControlLabel> {"Preço noturno"} </ControlLabel>
										{me.getPricesNightList()}
									</FormGroup>
								</Col>
							</div>
						</Row>
					</Col>
				</Row>
			</div>
		);
	}

});

module.exports = Settings;


// WEBPACK FOOTER //
// ./src/components/Admin/Settings.jsx